import { Component } from '@angular/core';

@Component({
  selector: 'app-section-titulo-apoio-cultural',
  templateUrl: './section-titulo-apoio-cultural.component.html',
  styleUrls: ['./section-titulo-apoio-cultural.component.scss'],
})
export class SectionTituloApoioCulturalComponent {}
